export const addItemToCart = (cardItems, cardItemToAdd) => {
  const existingCardItem = cardItems.find(
    cardItem => cardItem.id === cardItemToAdd.id
  )

  if(existingCardItem) { 
    return cardItems.map(
      cardItem => cardItem.id === cardItemToAdd.id ?
      ({...cardItem, quantity: cardItem.quantity + 1}) : (cardItem)
    )
  }

  return [...cardItems, {...cardItemToAdd, quantity: 1}]
}


export const removeItemFromCart = (cartItems, cartItemToRemove) => {
  const existingCardItem = cartItems.find(
    cartItem => cartItem.id === cartItemToRemove.id
  )

  if(existingCardItem.quantity === 1) {
    return cartItems.filter(cartItem => cartItem.id !== cartItemToRemove.id)
  }

  return cartItems.map(
    cartItem => cartItem.id === cartItemToRemove.id ?
    ({...cartItem, quantity: cartItem.quantity - 1})
    :
    (cartItem)
  )

}




